import React, { memo } from 'react'
import AppointmentStatus, {
	AppointmentStatusSkeleton,
} from './AppointmentStatus'
import AppointmentBody, { AppointmentBodySkeleton } from './AppointmentBody'

import styles from './AppointmentCard.module.sass'

const AppointmentCard = memo(
	(props) => {
		const { className, data, ...attributes } = props
		const labels = data.$cardLabels || {}

		return (
			<div
				{...attributes}
				className={`card ${styles['root'] || ''} ${className || ''} ${
					styles[`${data?.$layout}-layout`] || ''
				}`}
			>
				<div>
					<AppointmentStatus data={data} labels={labels} />
				</div>
				{data?.status?.value === 'executed' &&
					data.$detailLevel !== 'summary' && (
						<AppointmentBody data={data} labels={labels} />
					)}
			</div>
		)
	},
	(prevProps, nextProps) =>
		prevProps.data.id === nextProps.data.id &&
		prevProps.data.$layout === nextProps.data.$layout &&
		prevProps.data.$detailLevel === nextProps.data.$detailLevel &&
		prevProps.data.$highlight === nextProps.data.$highlight &&
		prevProps.data.textHeight === nextProps.data.textHeight &&
		prevProps.style.top === nextProps.style.top &&
		prevProps.data?.$textHighlight?.query ===
			nextProps.data?.$textHighlight?.query
)

AppointmentCard.displayName = 'AppointmentCard'
AppointmentCard.executedDefaultHeight = 152
AppointmentCard.statusDefaultHeight = 56
AppointmentCard.historyRowSize = 26
AppointmentCard.defaultHeight = 56
AppointmentCard.defaultLines = 0

export default AppointmentCard

export const AppointmentCardSkeleton = () => {
	return (
		<div className={`card ${styles['root']}`}>
			<div>
				<AppointmentStatusSkeleton />
			</div>
			<AppointmentBodySkeleton />
		</div>
	)
}
AppointmentCardSkeleton.displayName = 'AppointmentCardSkeleton'
AppointmentCardSkeleton.defaultHeight = 93
AppointmentCardSkeleton.verticalDefaultHeight = 119
